export enum ProviderTaskFieldType
{
    Text = 'Text',
    Password = 'Password',
    EMail = 'EMail',
    Numeric = 'Numeric',
    Date = 'Date',
    DateTime = 'DateTime',
    TextArea = 'TextArea'
}
